
import { Checkbox, Selection, DetailsHeader, DetailsList, DetailsListLayoutMode, DetailsRow, ICheckboxStyles, IColumn, Icon, IDetailsColumnProps, IDetailsColumnStyles, IDetailsHeaderProps, IDetailsHeaderStyles, IDetailsRowProps, IRenderFunction, Link, ProgressIndicator, SelectionMode, Stack, TooltipHost, useTheme, Label } from '@fluentui/react';
import * as React from 'react';
import { IEventSchedule } from '../../../../../Models/Event/IEventSchedule';
import { ISchedulesTeacherList } from '../../../../../Models/Event/ISchedulesTeacherList';

interface ITeachersListViewProps {
    eventSchedule?: IEventSchedule;
    items: ISchedulesTeacherList[]
    selectTeacher: (teacher: ISchedulesTeacherList) => void;
    deleteTeacher: (item: ISchedulesTeacherList) => void;
    canEdit: boolean;
}


export const TeachersListView: React.FunctionComponent<ITeachersListViewProps> = (props) => {

    const [columns, setColumns] = React.useState<IColumn[]>([]);
    const [selected, setSelected] = React.useState<ISchedulesTeacherList[]>([]);
    const [selectionState] = React.useState(new Selection({
        onSelectionChanged: () => {
            const selected = selectionState.getSelection() as ISchedulesTeacherList[];
            setSelected(selected);
        },
        selectionMode: SelectionMode.single
    }));


    const theme = useTheme();
    const checkBoxStyle: Partial<ICheckboxStyles> = {
        root: {

        },
        label: {
            color: theme.palette.black, fontWeight: 400, fontSize: theme.fonts.small.fontSize,

        },
        text: { color: theme.palette.black, fontWeight: 400, fontSize: theme.fonts.small.fontSize, }
    }

    const headerStyle: Partial<IDetailsColumnStyles> = {
        cellName: {
            fontFamily: "Comfortaa, serif",
            color: theme.palette.blue,
        },
    }

    const buildColumns = () => {
        const _columns: IColumn[] = [
            { key: 'firstName', isCollapsible: true, name: 'Jméno', fieldName: 'firstname', minWidth: 100, maxWidth: 200, isResizable: true, styles: headerStyle },
            { key: 'lastName', name: 'Příjmení', fieldName: 'lastname', minWidth: 100, maxWidth: 400, isResizable: true, styles: headerStyle },
            { key: 'lessons', name: 'Počet lekcí', fieldName: 'lessons', minWidth: 80, maxWidth: 100, isResizable: true, styles: headerStyle },
            { key: 'deleteButton', name: "delete", minWidth: 50, isIconOnly: true }
        ];
        setColumns(_columns);
    }


    const renderItemColumn = (item: ISchedulesTeacherList, index?: number, column?: IColumn) => {
        if (index != undefined && column != undefined) {
            const fieldContent = item[column.fieldName as keyof ISchedulesTeacherList];
            switch (column.key) {
                case 'deleteButton':
                    return <div><Link
                        disabled={!props.canEdit}
                        title={fieldContent as string} onClick={() => { props.deleteTeacher(item) }}><Icon styles={{ root: { fontSize: 16 } }} iconName="Delete" /></Link ></div>;
                default:
                    return <span style={{ height: '100%', display: 'flex', alignItems: 'center' }}>{fieldContent}</span>;
            }
        }
        else {
            return (<div></div>)
        }
    }
    const headerRowStyle: Partial<IDetailsHeaderStyles> = {
        root: {
            borderColor: theme.palette.blue,
            borderBottomWidth: 2
        }
    }
    const onRenderDetailsHeader: IRenderFunction<IDetailsHeaderProps> = (props, defaultRender) => {
        if (props) {
            props = { ...props, styles: headerRowStyle };
            return (
                <DetailsHeader
                    {...props}
                />
            );
        }
        return null;
    }
  
    React.useEffect(() => {
        buildColumns();
    },[])


    return (<>        
        <DetailsList
        items={props.items}
        columns={columns}
        setKey="set"
        onRenderDetailsHeader={onRenderDetailsHeader}
        selectionMode={SelectionMode.single}

        layoutMode={DetailsListLayoutMode.justified}
        onRenderItemColumn={renderItemColumn}
        selection={selectionState}
        selectionPreservedOnEmptyClick={false}
        ariaLabelForSelectionColumn="Výběr věkové skupiny"
        ariaLabelForSelectAllCheckbox="Výběr věkové skupiny"
        checkButtonAriaLabel="Vyber řádek"
        
            onItemInvoked={props.selectTeacher} />

        </>)
}
